import { getAuth } from "@firebase/auth";
import { useEffect, useState } from "react";
import DeleteTransport from "../../../../Controllers/Admin/Transports/DeleteTransport";
import GetAllTransports from "../../../../Controllers/Admin/Transports/GetAllTransports";
import GetUser from "../../../../Controllers/Users/GetUser";
import { ToastSuccessMessages } from "../../../../Helpers/ToastMessages";

export default function TransportListingViewModel() {
  const [TransportID, setTransportID] = useState("");
  const [SchoolID, setSchoolID] = useState("");
  const [IsLoading, setIsLoading] = useState(true);
  const [Refresh, setRefresh] = useState(true);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  const [AuthUser, setAuthUser] = useState();
  const [TransportsArray, setTransportsArray] = useState([]);

  const HandleRefresh = () => {
    setIsLoading(true);
    setRefresh(!Refresh);
  };

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const TransportsData = await GetAllTransports(AuthUser?.uid, SchoolID);
      setTransportsArray(TransportsData);
      setIsLoading(false);
    }
    fetchData();
  }, [AuthUser?.uid, SchoolID, Refresh]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);

  const handleOpenDeleteDialog = (id) => {
    setTransportID(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteTransport(TransportID);
      ToastSuccessMessages("transport/delete-successful");
      HandleRefresh();
      setDeleteDialog(false);
    }
  };
  // Action Confirmation End

  return {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    TransportsArray,
    IsLoading,
  };
}
